import typeahead from '@app/adapters/typeahead'
import './changelog'
import './whats-new'
import './color-picker'
import './pulse-files-upload'
import setupAdminUsers from './setup-admin-users'
import setupAutoComplete from './setup-auto-complete'
import setupBackgroundPolling from './setup-background-polling'
import setupBootstrap from './setup-bootstrap'
import setupMluRetainedEarningsAccount from './mlu-retained-earnings-account'
import setupProgressChecker from './setup-progress-checker'
import setupSanitization from './setup-sanitization'
import './track-event'
import './add-confirmation-modal'
import './fetch-package-confirmation-modal'
import './update-company-template'

setupAdminUsers()
setupAutoComplete({ onDomLoad: window.onDomLoad, typeahead })
setupBackgroundPolling()
setupBootstrap()
setupMluRetainedEarningsAccount()
setupProgressChecker()
setupSanitization()
